import React, { memo } from 'react'

//@ts-ignore
const CurrentLocationComponent = memo(({ styles, lat, lng, accuracy }) => {
  return (
    <>
      <div className="c_current_locaiotion">
        <div className={styles.c_pin_current}>
          <img src={`${process.env.NEXT_PUBLIC_SITEURL}/images/img_current_pin.svg`} alt="" />
        </div>
      </div>
      {/* <div className="demo">
        <p className="text-xs text-center">-- 追跡中 --</p>
        <p className="text-xs">latitude : {lat}</p>
        <p className="text-xs">longitude : {lng}</p>
        <p className="text-xs">accuracy（誤差） : {accuracy}</p>
      </div> */}
    </>
  )
})

CurrentLocationComponent.displayName = 'CurrentLocationComponent'

export default CurrentLocationComponent
